import { useState } from 'react';
import { Container, ListGroup } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import YouTube from 'react-youtube';

const VIDEO_ID = "BQeZ9nJnNns";

const CapabilitiesVideo = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const opts = { height: '390', width: '640' };

    const _onReady = (event) => {
        event.target.playVideo();
    }

    if (isPlaying) {
        return <YouTube className="youtube" containerClassName="youtubeholder" videoId={VIDEO_ID} opts={opts} onReady={_onReady} />;
    }

    return (
        <button
            type="button"
            className="youtube youtube-facade"
            aria-label="Play video"
            onClick={() => setIsPlaying(true)}
        >
            <img
                src={`https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`}
                alt="SOFTAC capabilities video thumbnail"
                loading="eager"
            />
            <span className="youtube-playbutton" aria-hidden="true">&#9658;</span>
        </button>
    );
}

const Capabilities = () => {
        return (
            <>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>SOFTAC | Capabilities</title>
                    <link rel="canonical" href="https://www.softac.com/capabilities" />
                    <meta name="description" content="SOFTAC’s team of engineers, software developers and technicians make selecting us as an integrator an easy decision." />

                </Helmet>

                <div className="page-shell">
                <Container>
                    <h1 className="header-highlight">Our Capabilities</h1>

                    <p className="intro-text">SOFTAC’s team of engineers, software developers and technicians make selecting us as an integrator an easy decision. Over 50 years of experience in design, development and manufacturing makes us one of the longest standing businesses in our industry. Our diverse portfolio of projects over our tenure gives you the assurance that we are very capable of taking on your project.</p>

                    <div className="youtubeholder">
                        <CapabilitiesVideo />
                    </div>

                    <section className="info-section">
                        <ListGroup>
                            <div><h4>Work We Do On A Regular Basis</h4></div>
                            <ListGroup.Item className="cardstyles">Custom controls design & packaging</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Ski lift or gondola drive systems</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Wastewater & water treatment kiosks and controls</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Most aspects of sawmill controls</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">MCC's & Power distribution systems</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Variable speed drive builds and harmonic distortion mitigation</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Marine controls for automated door systems and automated winches</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Mobile controls combining engines, transmissions and hydraulics</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Electronic soft starters and DC injection brakes</ListGroup.Item>
                        </ListGroup>
                    </section>

                    <section className="info-section">
                        <ListGroup>
                            <div><h4>Engineering and Design</h4></div>
                            <ListGroup.Item className="cardstyles">Engineers</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Draftsman</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">PLC Programmers - competent in all major brands</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">HMI Programmers - competent in all major brand</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Proficient in use of various electrical CAD tools, specializing in WS CAD and Eplan</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Automated submittal process</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">AutoCAD, AutoCAD Electrical, and MS Visio</ListGroup.Item>
                        </ListGroup>
                    </section>

                    <section className="info-section">
                        <ListGroup>
                            <div><h4>Information Technology Skills</h4></div>
                            <ListGroup.Item className="cardstyles">Windows, Mac, and Linux Operating Systems</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Rust, C, C++, JavaScript, Python, and PHP</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">API, IoT, Google Scripts, and webserver integration</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Self-healing containerization with Docker</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Application development for web and mobile platforms</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Software compilation targeted to specific architectures</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">AWS and Google cloud platforms</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Hardware and software experience with I2C, SPI, GPIO and other device drivers</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Internally developed secure practices for remote PLC management</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Long-distance communications over TCP/IP, Modbus, LoRaWAN, and MQTT</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">.NET (C# / ASP.NET)</ListGroup.Item>
                        </ListGroup>
                    </section>

                    <section className="info-section">
                        <ListGroup>
                            <div><h4>Our Facilities</h4></div>
                            <ListGroup.Item className="cardstyles">5,000 square feet centrally located in the industrial area of Chilliwack, British Columbia</ListGroup.Item>
                            <ListGroup.Item className="cardstyles">Centralized and dedicated office space for engineering, admin work, sales and staff lunchroom.</ListGroup.Item>
                        </ListGroup>
                    </section>
                </Container>
                </div>
            </>

        )

    }
export default Capabilities;

